import {Card, DataStatus, Segment, Separator} from 'platform/components';
import {Box, Show, VStack} from 'platform/foundation';

import {useState} from 'react';

import {useGetPartMovementsCountQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import type {EagGridMaximization} from 'features/eag-grid';

import {ServiceCaseOrderFastTrackItemsDataGrid} from './ServiceCaseOrderFastTrackItemsDataGrid';
import {ServiceCaseOrderIssuesDataGrid} from './ServiceCaseOrderIssuesDataGrid';
import {ServiceCaseOrderReturnsDataGrid} from './ServiceCaseOrderReturnsDataGrid';

interface PartsMovementsProps {
  maximization?: EagGridMaximization;
  serviceCaseId: string;
  orderId: string;
}

enum Segments {
  ISSUES = 'issues',
  RETURNS = 'returns',
  FAST_TRACK_ITEMS = 'fastTrackItems',
}

export function PartsMovements(props: PartsMovementsProps) {
  const [activeSegment, setActiveSegment] = useState<Segments>(Segments.ISSUES);
  const {data: partsMovementCount, isLoading: isPartsMovementCountLoading} =
    useGetPartMovementsCountQuery(
      {
        serviceCaseId: props.serviceCaseId,
        serviceOrderId: props.orderId,
      },
      {skip: !props.serviceCaseId || !props.orderId}
    );

  return (
    <DataStatus isLoading={isPartsMovementCountLoading}>
      <Card>
        <VStack spacing={4}>
          <Box width="fit-content">
            <Segment
              value={activeSegment}
              onChange={setActiveSegment}
              options={[
                {
                  label: i18n.t('page.workshop.labels.serviceOrderIssues', {
                    count: partsMovementCount?.serviceOrderIssuesCount ?? 0,
                  }),
                  value: Segments.ISSUES,
                },
                {
                  label: i18n.t('page.workshop.labels.serviceOrderReturns', {
                    count: partsMovementCount?.serviceOrderReturnsCount ?? 0,
                  }),
                  value: Segments.RETURNS,
                },
                {
                  label: i18n.t('page.workshop.labels.fastTrackIssueItems', {
                    count: partsMovementCount?.fastTrackIssuesCount ?? 0,
                  }),
                  value: Segments.FAST_TRACK_ITEMS,
                },
              ]}
            />
          </Box>
          <Separator spacing={0} />
          <Show when={activeSegment === Segments.ISSUES}>
            <ServiceCaseOrderIssuesDataGrid
              maximization={props.maximization}
              orderId={props.orderId}
            />
          </Show>
          <Show when={activeSegment === Segments.RETURNS}>
            <ServiceCaseOrderReturnsDataGrid
              maximization={props.maximization}
              orderId={props.orderId}
            />
          </Show>
          <Show when={activeSegment === Segments.FAST_TRACK_ITEMS}>
            <ServiceCaseOrderFastTrackItemsDataGrid
              maximization={props.maximization}
              orderId={props.orderId}
            />
          </Show>
        </VStack>
      </Card>
    </DataStatus>
  );
}
